import * as React from 'react';
export const IcDevicesMixed = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.29 18.29A1 1 0 008 19a1 1 0 00.29.71A1 1 0 009 20h3v-2H9a1 1 0 00-.71.29zM20 7a3.91 3.91 0 012 .58V6a2 2 0 00-2-2H4a2 2 0 00-2 2v9a2 2 0 002 2h8v-5.84A4.1 4.1 0 0116 7h4zm1.45 2.67A2.16 2.16 0 0020 9h-4a2.16 2.16 0 00-1.45.67 2.13 2.13 0 00-.55 1.5v8.66a2.11 2.11 0 00.55 1.5A2.08 2.08 0 0016 22h4a2.08 2.08 0 001.45-.67 2.11 2.11 0 00.55-1.5v-8.67a2.13 2.13 0 00-.55-1.5v.01zm-2.74 10A1.001 1.001 0 0118 20a1 1 0 01-.858-.487 1 1 0 01.148-1.213 1 1 0 01.51-.3 1 1 0 01.58.06c.187.07.345.2.45.37A1 1 0 0119 19a1 1 0 01-.29.7v-.03z'
      fill='currentColor'
    />
  </svg>
);
